{
  "title": "체크인을 완료할 수 없습니다",
  "message": "신분증을 확인할 수 없습니다"
}
